module.exports = __webpack_public_path__ + "img/1387698688.cb97e1e3.jpg";